import { useEffect, useRef, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";


//eHuda
import aE from "../src/assets/img/eHuda/aE.png";
import beE from "../src/assets/img/eHuda/beE.png";
import buE from "../src/assets/img/eHuda/buE.png";
import eE from "../src/assets/img/eHuda/eE.png";
import haE from "../src/assets/img/eHuda/haE.png";
import hoE from "../src/assets/img/eHuda/hoE.png";
import huE from "../src/assets/img/eHuda/huE.png";
import iE from "../src/assets/img/eHuda/iE.png";
import jiE from "../src/assets/img/eHuda/jiE.png";
import kaE from "../src/assets/img/eHuda/kaE.png";
import keE from "../src/assets/img/eHuda/keE.png";
import kiE from "../src/assets/img/eHuda/kiE.png";
import koE from "../src/assets/img/eHuda/koE.png";
import kuE from "../src/assets/img/eHuda/kuE.png";
import maE from "../src/assets/img/eHuda/maE.png";
import meE from "../src/assets/img/eHuda/meE.png";
import miE from "../src/assets/img/eHuda/miE.png";
import moE from "../src/assets/img/eHuda/moE.png";
import muE from "../src/assets/img/eHuda/muE.png";
import naE from "../src/assets/img/eHuda/naE.png";
import neE from "../src/assets/img/eHuda/neE.png";
import niE from "../src/assets/img/eHuda/niE.png";
import noE from "../src/assets/img/eHuda/noE.png";
import nuE from "../src/assets/img/eHuda/nuE.png";
import oE from "../src/assets/img/eHuda/oE.png";
import paE from "../src/assets/img/eHuda/paE.png";
import piE from "../src/assets/img/eHuda/piE.png";
import raE from "../src/assets/img/eHuda/raE.png";
import riE from "../src/assets/img/eHuda/riE.png";
import roE from "../src/assets/img/eHuda/roE.png";
import ruE from "../src/assets/img/eHuda/ruE.png";
import saE from "../src/assets/img/eHuda/saE.png";
import seE from "../src/assets/img/eHuda/seE.png";
import shiE from "../src/assets/img/eHuda/shiE.png";
import soE from "../src/assets/img/eHuda/soE.png";
import suE from "../src/assets/img/eHuda/suE.png";
import taE from "../src/assets/img/eHuda/taE.png";
import teE from "../src/assets/img/eHuda/teE.png";
import tiE from "../src/assets/img/eHuda/tiE.png";
import toE from "../src/assets/img/eHuda/toE.png";
import tuE from "../src/assets/img/eHuda/tuE.png";
import uE from "../src/assets/img/eHuda/uE.png";
import waE from "../src/assets/img/eHuda/waE.png";
import yaE from "../src/assets/img/eHuda/yaE.png";
import yoE from "../src/assets/img/eHuda/yoE.png";
import yuE from "../src/assets/img/eHuda/yuE.png";



//yomiHuda
import aYomi from "../src/assets/img/yomiHuda/aYomi.png";
import beYomi from "../src/assets/img/yomiHuda/beYomi.png";
import buYomi from "../src/assets/img/yomiHuda/buYomi.png";
import eYomi from "../src/assets/img/yomiHuda/eYomi.png";
import haYomi from "../src/assets/img/yomiHuda/haYomi.png";
import hoYomi from "../src/assets/img/yomiHuda/hoYomi.png";
import huYomi from "../src/assets/img/yomiHuda/huYomi.png";
import iYomi from "../src/assets/img/yomiHuda/iYomi.png";
import jiYomi from "../src/assets/img/yomiHuda/jiYomi.png";
import kaYomi from "../src/assets/img/yomiHuda/kaYomi.png";
import keYomi from "../src/assets/img/yomiHuda/keYomi.png";
import kiYomi from "../src/assets/img/yomiHuda/kiYomi.png";
import koYomi from "../src/assets/img/yomiHuda/koYomi.png";
import kuYomi from "../src/assets/img/yomiHuda/kuYomi.png";
import maYomi from "../src/assets/img/yomiHuda/maYomi.png";
import meYomi from "../src/assets/img/yomiHuda/meYomi.png";
import miYomi from "../src/assets/img/yomiHuda/miYomi.png";
import moYomi from "../src/assets/img/yomiHuda/moYomi.png";
import muYomi from "../src/assets/img/yomiHuda/muYomi.png";
import naYomi from "../src/assets/img/yomiHuda/naYomi.png";
import neYomi from "../src/assets/img/yomiHuda/neYomi.png";
import niYomi from "../src/assets/img/yomiHuda/niYomi.png";
import noYomi from "../src/assets/img/yomiHuda/noYomi.png";
import nuYomi from "../src/assets/img/yomiHuda/nuYomi.png";
import oYomi from "../src/assets/img/yomiHuda/oYomi.png";
import paYomi from "../src/assets/img/yomiHuda/paYomi.png";
import piYomi from "../src/assets/img/yomiHuda/piYomi.png";
import raYomi from "../src/assets/img/yomiHuda/raYomi.png";
import riYomi from "../src/assets/img/yomiHuda/riYomi.png";
import roYomi from "../src/assets/img/yomiHuda/roYomi.png";
import ruYomi from "../src/assets/img/yomiHuda/ruYomi.png";
import saYomi from "../src/assets/img/yomiHuda/saYomi.png";
import seYomi from "../src/assets/img/yomiHuda/seYomi.png";
import shiYomi from "../src/assets/img/yomiHuda/shiYomi.png";
import soYomi from "../src/assets/img/yomiHuda/soYomi.png";
import suYomi from "../src/assets/img/yomiHuda/suYomi.png";
import taYomi from "../src/assets/img/yomiHuda/taYomi.png";
import teYomi from "../src/assets/img/yomiHuda/teYomi.png";
import tiYomi from "../src/assets/img/yomiHuda/tiYomi.png";
import toYomi from "../src/assets/img/yomiHuda/toYomi.png";
import tuYomi from "../src/assets/img/yomiHuda/tuYomi.png";
import uYomi from "../src/assets/img/yomiHuda/uYomi.png";
import waYomi from "../src/assets/img/yomiHuda/waYomi.png";
import yaYomi from "../src/assets/img/yomiHuda/yaYomi.png";
import yoYomi from "../src/assets/img/yomiHuda/yoYomi.png";
import yuYomi from "../src/assets/img/yomiHuda/yuYomi.png";


//sound
import aSound from "../src/assets/sound/aSound.wav";
import beSound from "../src/assets/sound/beSound.wav";
import buSound from "../src/assets/sound/buSound.wav";
import eSound from "../src/assets/sound/eSound.wav";
import haSound from "../src/assets/sound/haSound.wav";
import hoSound from "../src/assets/sound/hoSound.wav";
import huSound from "../src/assets/sound/huSound.wav";
import iSound from "../src/assets/sound/iSound.wav";
import jiSound from "../src/assets/sound/jiSound.wav";
import kaSound from "../src/assets/sound/kaSound.wav";
import keSound from "../src/assets/sound/keSound.wav";
import kiSound from "../src/assets/sound/kiSound.wav";
import koSound from "../src/assets/sound/koSound.wav";
import kuSound from "../src/assets/sound/kuSound.wav";
import maSound from "../src/assets/sound/maSound.wav";
import meSound from "../src/assets/sound/meSound.wav";
import miSound from "../src/assets/sound/miSound.wav";
import moSound from "../src/assets/sound/moSound.wav";
import muSound from "../src/assets/sound/muSound.wav";
import naSound from "../src/assets/sound/naSound.wav";
import neSound from "../src/assets/sound/neSound.wav";
import niSound from "../src/assets/sound/niSound.wav";
import noSound from "../src/assets/sound/noSound.wav";
import nuSound from "../src/assets/sound/nuSound.wav";
import oSound from "../src/assets/sound/oSound.wav";
import paSound from "../src/assets/sound/paSound.wav";
import piSound from "../src/assets/sound/piSound.wav";
import raSound from "../src/assets/sound/raSound.wav";
import riSound from "../src/assets/sound/riSound.wav";
import roSound from "../src/assets/sound/roSound.wav";
import ruSound from "../src/assets/sound/ruSound.wav";
import saSound from "../src/assets/sound/saSound.wav";
import seSound from "../src/assets/sound/seSound.wav";
import shiSound from "../src/assets/sound/shiSound.wav";
import soSound from "../src/assets/sound/soSound.wav";
import suSound from "../src/assets/sound/suSound.wav";
import taSound from "../src/assets/sound/taSound.wav";
import teSound from "../src/assets/sound/teSound.wav";
import tiSound from "../src/assets/sound/tiSound.wav";
import toSound from "../src/assets/sound/toSound.wav";
import tuSound from "../src/assets/sound/tuSound.wav";
import uSound from "../src/assets/sound/uSound.wav";
import waSound from "../src/assets/sound/waSound.wav";
import yaSound from "../src/assets/sound/yaSound.wav";
import yoSound from "../src/assets/sound/yoSound.wav";
import yuSound from "../src/assets/sound/yuSound.wav";



import buttonEffect from "./assets/sound/effect/buttonEffect.mp3";

//Sdgs huda
import aSdgs from "../src/assets/img/sdgsHuda/aSdgs.png"
import beSdgs from "../src/assets/img/sdgsHuda/beSdgs.png"
import buSdgs from "../src/assets/img/sdgsHuda/buSdgs.png";
import eSdgs from "../src/assets/img/sdgsHuda/eSdgs.png";
import haSdgs from "../src/assets/img/sdgsHuda/haSdgs.png";
import hoSdgs from "../src/assets/img/sdgsHuda/hoSdgs.png";
import huSdgs from "../src/assets/img/sdgsHuda/huSdgs.png";
import iSdgs from "../src/assets/img/sdgsHuda/iSdgs.png";
import jiSdgs from "../src/assets/img/sdgsHuda/jiSdgs.png";
import kaSdgs from "../src/assets/img/sdgsHuda/kaSdgs.png";
import keSdgs from "../src/assets/img/sdgsHuda/keSdgs.png";
import kiSdgs from "../src/assets/img/sdgsHuda/kiSdgs.png";
import koSdgs from "../src/assets/img/sdgsHuda/koSdgs.png";
import kuSdgs from "../src/assets/img/sdgsHuda/kuSdgs.png";
import maSdgs from "../src/assets/img/sdgsHuda/maSdgs.png";
import meSdgs from "../src/assets/img/sdgsHuda/meSdgs.png";
import miSdgs from "../src/assets/img/sdgsHuda/miSdgs.png";
import moSdgs from "../src/assets/img/sdgsHuda/moSdgs.png";
import muSdgs from "../src/assets/img/sdgsHuda/muSdgs.png";
import naSdgs from "../src/assets/img/sdgsHuda/naSdgs.png";
import neSdgs from "../src/assets/img/sdgsHuda/neSdgs.png";
import niSdgs from "../src/assets/img/sdgsHuda/niSdgs.png";
import noSdgs from "../src/assets/img/sdgsHuda/noSdgs.png";
import nuSdgs from "../src/assets/img/sdgsHuda/nuSdgs.png";
import oSdgs from "../src/assets/img/sdgsHuda/oSdgs.png";
import paSdgs from "../src/assets/img/sdgsHuda/paSdgs.png";
import piSdgs from "../src/assets/img/sdgsHuda/piSdgs.png";
import raSdgs from "../src/assets/img/sdgsHuda/raSdgs.png";
import riSdgs from "../src/assets/img/sdgsHuda/riSdgs.png";
import roSdgs from "../src/assets/img/sdgsHuda/roSdgs.png";
import ruSdgs from "../src/assets/img/sdgsHuda/ruSdgs.png";
import saSdgs from "../src/assets/img/sdgsHuda/saSdgs.png";
import seSdgs from "../src/assets/img/sdgsHuda/seSdgs.png";
import shiSdgs from "../src/assets/img/sdgsHuda/shiSdgs.png";
import soSdgs from "../src/assets/img/sdgsHuda/soSdgs.png";
import suSdgs from "../src/assets/img/sdgsHuda/suSdgs.png";
import taSdgs from "../src/assets/img/sdgsHuda/taSdgs.png";
import teSdgs from "../src/assets/img/sdgsHuda/teSdgs.png";
import tiSdgs from "../src/assets/img/sdgsHuda/tiSdgs.png";
import toSdgs from "../src/assets/img/sdgsHuda/toSdgs.png";
import tuSdgs from "../src/assets/img/sdgsHuda/tuSdgs.png";
import uSdgs from "../src/assets/img/sdgsHuda/uSdgs.png";
import waSdgs from "../src/assets/img/sdgsHuda/waSdgs.png";
import yaSdgs from "../src/assets/img/sdgsHuda/yaSdgs.png";
import yoSdgs from "../src/assets/img/sdgsHuda/yoSdgs.png";
import yuSdgs from "../src/assets/img/sdgsHuda/yuSdgs.png";
import { useDispatch, useSelector } from "react-redux";
import CustomHuda from "../src/model/CustomHuda";
import "./App.css";
import bgm from "./assets/bgm/isida1.mp3";
import FreeImage from "./assets/img/isida2.jpg";
import FreeImage2 from "./assets/background_vertical.jpg";
import FreeImage3 from "./assets/background_horizon.png"
import IntroducePage from "./pages/IntroducePage";
import { useMediaQuery } from "react-responsive";
import useSound from "use-sound";
import { buttonEffectSetFalse } from "./features/buttonEffect/ButtonEffectSlice";
import Advanced from "./pages/Advanced";
import PlayPage from "./pages/PlayPage";
import PlayPageAuto from "./pages/PlayPageAuto";
import SelectSDGsNum from "./pages/SelectSDGsNum";
import SettingPage from "./pages/SettingPage";
import { Height, Landscape } from "@mui/icons-material";
import SelectMultipleSDGsNum from "./pages/SelectMultipleSDGsNum";

function App() {
    const customHudaList = [
        new CustomHuda(0, aSound, aE, aYomi, aSdgs, "あ", "ありがとう/ 全[すべ]て の命[いのち]に/かんしゃを", 16),
        new CustomHuda(1, beSound, beE, beYomi, beSdgs, "べ", "べんりだな/ごはんを 運[はこ] ぶ/ロボットだ", 9),
        new CustomHuda(2, buSound, buE, buYomi, buSdgs, "ぶ", "ブルーピンク/ぼくもわたしも/すきでいい", 5),
        new CustomHuda(3, eSound, eE, eYomi, eSdgs, "え", "エコバッグ/いつもいしょに/お買[か]い物[もの]", 12),
        new CustomHuda(4, haSound, haE, haYomi, haSdgs, "は", "花[はな]たちの/みらいをまもろう/きみの手[て]で", 15),
        new CustomHuda(5, hoSound, hoE, hoYomi, hoSdgs, "ほ", "放[ほう]っておくと/ 地球[ちきゅう] はどんどん/ 弱[よわ] っていく", 15),
        new CustomHuda(6, huSound, huE, huYomi, huSdgs, "ふ", "ふやそう/ 世界[せかい]とつながる/インフラを", 9),
        new CustomHuda(7, iSound, iE, iYomi, iSdgs, "い", "いっしょだね/たがいを知[し]って/ともにゆく", 10),
        new CustomHuda(8, jiSound, jiE, jiYomi, jiSdgs, "じ", "十分[じゅうぶん] に/ 考[かんが] えてみよう/ 男女[だんじょ] さべつ", 5),
        new CustomHuda(9, kaSound, kaE, kaYomi, kaSdgs, "か", "かんがえよう/ 学校[がっこう]がある/しあわせを", 4),
        new CustomHuda(10, keSound, keE, keYomi, keSdgs, "け", "けんこうで/みんなのえがお/ひろがるね", 3),
        new CustomHuda(11, kiSound, kiE, kiYomi, kiSdgs, "き", "木[き]とともに/ 育[はぐく] む地球[ちきゅう]/みらいのために", 15),
        new CustomHuda(12, koSound, koE, koYomi, koSdgs, "こ", "「こんにちは」/ 人[ひと]がつながる/ 大切[たいせつ]なまち", 11),
        new CustomHuda(13, kuSound, kuE, kuYomi, kuSdgs, "く", "苦[くる]しみを/なくす 一歩[いっぽ] は/ 食[しょく]のしえん", 2),
        new CustomHuda(14, maSound, maE, maYomi, maSdgs, "ま", "マイバック/いつもわすれず/エコくらし", 13),
        new CustomHuda(15, meSound, meE, meYomi, meSdgs, "め", "めざそうよ/みらいの地球[ちきゅう] / 守[まも]る道[みち]", 13),
        new CustomHuda(16, miSound, miE, miYomi, miSdgs, "み", "みらいのため/しげんをむだなく/ 大切[たいせつ]に", 6),
        new CustomHuda(17, moSound, moE, moYomi, moSdgs, "も", "もどらいない/ 一度[いちど]よごした/ 広[ひろ]い海[うみ]", 14),
        new CustomHuda(18, muSound, muE, muYomi, muSdgs, "む", "むりのない/よいはたらき方[かた] /よいかんきょう", 8),
        new CustomHuda(19, naSound, naE, naYomi, naSdgs, "な", "なんてこと！/きれいな水[みず]を/のめるとは", 6),
        new CustomHuda(20, neSound, neE, neYomi, neSdgs, "ね", "ねがいこめて/ 使[つか]いすぎずに/ 電気[でんき]を大切[たいせつ]に", 7),
        new CustomHuda(21, niSound, niE, niYomi, niSdgs, "に", "日[にち]じょうの/ 風[ふう]けいは/ぼくのたから物[もの]", 11),
        new CustomHuda(22, noSound, noE, noYomi, noSdgs, "の", "のばそうよ/エコなみらいへ/ 電気[でんき]のくふう", 7),
        new CustomHuda(23, nuSound, nuE, nuYomi, nuSdgs, "ぬ", "ぬれた/てぬぐい/なんせべんり", 12),
        new CustomHuda(24, oSound, oE, oYomi, oSdgs, "お", "おとなでも/だれもが学[まな]べる/ 世界[せかい]にしよう", 4),
        new CustomHuda(25, paSound, paE, paYomi, paSdgs, "ぱ", "パートナー/なかま見[み]つけて/ 世界[せかい]をすくおう", 17),
        new CustomHuda(26, piSound, piE, piYomi, piSdgs, "ぴ", "ぴったりな/ 水[みず]のだし方[かた] /いしきしよう", 6),
        new CustomHuda(27, raSound, raE, raYomi, raSdgs, "ら", "ライフライン/くらしをささえる/ 大切[たいせつ]にね", 1),
        new CustomHuda(28, riSound, riE, riYomi, riSdgs, "り", "リサイクル/ 見[み]えてないけど/ 身近[みぢか]なそんざい", 12),
        new CustomHuda(29, roSound, roE, roYomi, roSdgs, "ろ", "ロックオン / みんなでできる/ことを取[と]り組[く]もう", 1),
        new CustomHuda(30, ruSound, ruE, ruYomi, ruSdgs, "る", "ルール 守[まも]り / 作[つく]るしんらい/ 平和[へいわ]への道[みち]", 16),
        new CustomHuda(31, saSound, saE, saYomi, saSdgs, "さ", "さけさんも/きっとえがおだね/ありがとう", 14),
        new CustomHuda(32, seSound, seE, seYomi, seSdgs, "せ", "生活[せいかつ]の/ロスをなくそう/みんなのために", 2),
        new CustomHuda(33, shiSound, shiE, shiYomi, shiSdgs, "し", "しぜんほご/みらいをまもるよ/ぼくたちが", 15),
        new CustomHuda(34, soSound, soE, soYomi, soSdgs, "そ", "「宙炭[そらたん]」で/よい畑[はたけ]を/たくさんつくろう", 2),
        new CustomHuda(35, suSound, suE, suYomi, suSdgs, "す", "スポーツで/ 心[こころ]も体[からだ]も/ 元気[げんき]いっぱい", 3),
        new CustomHuda(36, taSound, taE, taYomi, taSdgs, "た", "助[た]け合[あ]い/ 手[て]を取[と]り合[あ]って/ 歩[あゆ]む道[みち]", 8),
        new CustomHuda(37, teSound, teE, teYomi, teSdgs, "て", "てれないで/ 自分[じぶん]のことを/ 話[はな]し合[あ]おう", 16),
        new CustomHuda(38, tiSound, tiE, tiYomi, tiSdgs, "ち", "力[ちから] 合[あ] わせ/ゆめにさかいは/つくらない", 5),
        new CustomHuda(39, toSound, toE, toYomi, toSdgs, "と", "友[とも]だちって/ 色[いろ]んな人[ひと]がおるで/おもしろいんよ", 10),
        new CustomHuda(40, tuSound, tuE, tuYomi, tuSdgs, "つ", "つながる手[て] /まちを守[まも]ろう/ みんなの力[ちから]", 11),
        new CustomHuda(41, uSound, uE, uYomi, uSdgs, "う", "飢[う]えをなくす/みんながわらって/すごせるように", 1),
        new CustomHuda(42, waSound, waE, waYomi, waSdgs, "わ", "わかち 合[あ] う/そんちょうし 合[あ] う/ 平等[びょうどう]の", 5),
        new CustomHuda(43, yaSound, yaE, yaYomi, yaSdgs, "や", "やさしい手[て] /つなぎ広[ひろ]げて/ 地球[ちきゅう] 守[まも]る", 13),
        new CustomHuda(44, yoSound, yoE, yoYomi, yoSdgs, "よ", "よろこびを/ 広[ひろ]げる世界[せかい] / 公正[こうせい]に", 16),
        new CustomHuda(45, yuSound, yuE, yuYomi, yuSdgs, "ゆ", "ゆっくりと/できることから/むりはせず", 17),
    ];
    var innerHeight = window.innerHeight;
    var innerWidth = window.innerWidth;
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    const audioCtx = new AudioContext();
    const [myWidth, setMyWidth] = useState(0);
    const [windowSize, setWindowSize] = useState({
        width: innerWidth,
        height: innerHeight
    })
    const audioPlay = async (url) => {
        const context = new AudioContext();
        const source = context.createBufferSource();
        const audioBuffer = await fetch(url)
            .then((res) => res.arrayBuffer())
            .then((ArrayBuffer) => context.decodeAudioData(ArrayBuffer));

        source.buffer = audioBuffer;
        source.connect(context.destination);

        source.start();
    };
    const stopPlay = async (url) => {
        const context = new AudioContext();
        const source = context.createBufferSource();
        const audioBuffer = await fetch(url)
            .then((res) => res.arrayBuffer())
            .then((ArrayBuffer) => context.decodeAudioData(ArrayBuffer));

        source.buffer = audioBuffer;
        source.connect(context.destination);
    };
    const [isBgmOn, setIsBgmOn] = useState(true);
    const dispatcher = useDispatch();
    const bgmRef = useRef();
    const buttonEffectRef = useRef();
    const startBgm = () => {
        bgmRef.current.volume = 0.35;
        const playPromise = bgmRef.current.play();
        bgmRef.current.mute = false;
        if (playPromise !== undefined) {
            playPromise.then((_) => { }).catch((error) => { });
        }
    };
    const stopBgm = () => {
        bgmRef.current.pause();
    };
    useRef(() => {
        bgmRef.current.start();
    }, []);
    useRef(() => {
        bgmRef.current.start();
    });
    const startButtonEffect = () => {
        buttonEffectRef.current.load();
        const playPromise = buttonEffectRef.current.play();
        bgmRef.current.mute = false;
        if (playPromise !== undefined) {
            playPromise.then((_) => { }).catch((error) => { });
        }
    };
    const stopButtonEffect = () => {
        buttonEffectRef.current.pause();
    };
    const bgmFlg = useSelector((store) => store.bgm);
    const buttonEffectFlg = useSelector((store) => store.buttonEffect);
    useEffect(() => {
        if(isBgmOn)
        {
            if(bgmFlg)
            {
                startBgm();
            }else{
                stopBgm();
            }
        }else{
            stopBgm();
        }

    
    }, [bgmFlg, isBgmOn]);
    useEffect(() => {
        if (buttonEffectFlg) {
            startButtonEffect();
        } else {
            stopButtonEffect();
        }
    });
    useEffect(() => {
        setMyWidth(innerWidth);
    }, [innerWidth, innerHeight])
    const isWide = useMediaQuery({ query: "(min-width: 600px)" });
    const isLong = useMediaQuery({ query: "(min-height:600px)" });
    const isShort = useMediaQuery({ query: "(max-height:600px)" });
    const [isLandscape, setIsLandscape] = useState(window.innerWidth > window.innerHeight)

    useEffect(() => {


        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
            setIsLandscape(window.innerWidth > window.innerHeight);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, [])

    const [sdgsNum, setSdgsNum] = useState(1);
    const [pageNum, setPageNum] = useState(1);
    const [play] = useSound(buttonEffect);

    return (
        <BrowserRouter>
            <div
                className="App"
                style={
                    isWide
                        ? { backgroundImage: `url(${FreeImage3}) `, backgroundPositionX: "center", backgroundPositionY: "0", backgroundSize: `${innerWidth}px ${innerHeight}px`, WebkitBackgroundSize: `${innerWidth}px ${innerHeight}px`, backgroundRepeat: "no-repeat" }
                        : { backgroundImage: `url(${FreeImage2}) `, backgroundPositionX: "center", backgroundPositionY: "0", backgroundSize: `100% 100vh`, WebkitBackgroundSize: `${innerWidth}px ${innerHeight}px`, backgroundRepeat: "no-repeat" }
                }
            >
                <audio
                    preload="auto"
                    src={bgm}
                    ref={bgmRef}
                    muted={false}
                    loop={true}
                    onLoad={() => {
                      
                    }}
                    autoPlay={true}
                ></audio>

                <audio
                    preload="auto"
                    src={buttonEffect}
                    ref={buttonEffectRef}
                    muted={false}
                    loop={false}
                    autoPlay={false}
                    onEnded={() => {
                        dispatcher(buttonEffectSetFalse());
                    }}
                ></audio>
                {(!isShort || !isLandscape) && <div className="Custom-Container">
                    <Routes>
                        <Route path="/" element={<IntroducePage play={play} windowSize={windowSize} isBgmOn={isBgmOn} setIsBgmOn={setIsBgmOn}></IntroducePage>}></Route>
                        <Route path="/setting" element={<SettingPage play={play} customHudaList={customHudaList}></SettingPage>}></Route>
                        <Route path="/playAuto" element={<PlayPageAuto play={play} customHudaList={customHudaList}></PlayPageAuto>}></Route>
                        <Route path="/play" element={<PlayPage play={play} customHudaList={customHudaList}></PlayPage>}></Route>

                        <Route
                            path="/advanced"
                            element={<Advanced play={play} customHudaList={customHudaList} sdgsNum={sdgsNum}></Advanced>}
                        ></Route>
                        <Route
                            path="/selectNum"
                            element={
                                <SelectSDGsNum play={play} setNum={setSdgsNum} setPageNum={setPageNum} pageNum={pageNum}></SelectSDGsNum>
                            }
                        ></Route>
                        <Route
                            path="/selectMultipleSDGsNum"
                            element={
                                <SelectMultipleSDGsNum></SelectMultipleSDGsNum>
                            }
                        ></Route>
                    </Routes>
                    {isWide && (
                        <div>
                            <div
                                style={{
                                    fontSize: "1rem",
                                    fontWeight: "500",
                                    marginLeft: "auto",
                                    bottom: "28px",
                                    right: "35px",
                                    position: "fixed",
                                    // marginRight: "10px",
                                }}
                            >
                                © HONDALOGICOM Co.,LTD. All Rights Reserved.
                            </div>
                        </div>
                    )}
                </div>}
                {(isShort && isLandscape) &&
                    <div style={{ display: "flex", width: "100vw", height: "100vh", justifyContent: "center", alignItems: "center", fontSize: "2rem", fontWeight: "200" }}>
                        スマホは横向けには出来ないよ。<br></br>スマホを縦向きにしてね！
                    </div>
                }
            </div>
        </BrowserRouter>
    );
}

export default App;
